import { useEffect, useRef, useState } from 'react';
import { FiSearch, FiX } from 'react-icons/fi';
import { NavLink, useLocation } from 'react-router-dom';
import { activeNavigationPath, prepareNavigation } from './navigationUtils';

export default function NavigationMenu({ items, onNavigate, idPrefix, compact = false }) {
    const { pathname } = useLocation();
    const [search, setSearch] = useState('');
    const navigation = prepareNavigation(items, search);
    const activePath = activeNavigationPath(items, pathname);
    const scroll = useRef(null);
    useEffect(() => {
        scroll.current?.querySelector('.is-active')?.scrollIntoView?.({ block: 'nearest', inline: 'nearest' });
    }, [activePath, compact]);

    const renderLink = (item) => <NavLink key={item.to} to={item.to}
        isActive={() => item.to === activePath} activeClassName="is-active" aria-current="page"
        title={compact ? item.label : undefined} aria-label={compact ? item.label : undefined}
        className="portal-nav-link" onClick={() => { setSearch(''); onNavigate?.(); }}>
        <span className="portal-nav-icon" aria-hidden="true">{item.icon}</span>
        <span>{item.label}</span>
        {item.to === activePath && <span className="portal-nav-current" aria-hidden="true" />}
    </NavLink>;

    return <div className="portal-navigation">
        {!compact && <div className="portal-nav-search">
            <FiSearch aria-hidden="true" />
            <input type="search" aria-label="Search navigation" placeholder="Find a page…" value={search}
                onChange={(event) => setSearch(event.target.value)} />
            {search && <button type="button" aria-label="Clear navigation search" onClick={() => setSearch('')}><FiX aria-hidden="true" /></button>}
        </div>}
        <nav ref={scroll} aria-label="Portal navigation" className="portal-nav-scroll">
            <ul className="portal-nav-list">
                {navigation.map((item) => {
                    if (item.type === 'link') return <li key={item.to}>{renderLink(item)}</li>;
                    const headingId = `${idPrefix}-${item.id}-heading`;
                    return <li key={item.id} className="portal-nav-group">
                        <h2 id={headingId} className="portal-nav-section-heading">{item.label}</h2>
                        <ul aria-labelledby={headingId} className="portal-nav-children">
                            {item.children.map((child) => <li key={child.to}>{renderLink(child)}</li>)}
                        </ul>
                    </li>;
                })}
            </ul>
            {!navigation.length && <div className="portal-nav-empty" role="status">
                <strong>No matching pages</strong><p>Try another name or clear your search.</p>
                <button type="button" onClick={() => setSearch('')}>Clear search</button>
            </div>}
        </nav>
    </div>;
}
